/* eslint-disable no-console */
import React from 'react';
import { connect } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import { get } from 'lodash';
import IdentityCheck from './identityCheck';
import Main from './Main';
import { getPageId } from './utils';
import { getParams } from './util';
import GetNewUID from './Pages/GetNewUID';

/**
 * This component will make sure to initiate initial /questions call once identity check is veriied
 * Hence, maintaining identity check status in redux to verify app activity before dispatching any questions calls
 * Identity check is disabled for SSO user by default
 */
const InitiateApplication = ({ config, ssoAuthConfig, identity }) => {
  const uid = getParams('uid');
  const pageId = getPageId();
  const isSSOUser = (getParams('role') || '').toLowerCase() === ssoAuthConfig.SSO_USER_TYPE;
  const { enable = false, pages } = get(config, 'features.identityCheck', {});
  const enableIdentity =
    !isSSOUser &&
    ((enable && Array.isArray(pages) && pages.includes(pageId)) || (enable && !pages));

  let identityChecked;
  if (!uid || !pageId || pageId === 'inactivesession') {
    identityChecked = true;
  } else {
    identityChecked = ['valid', 'invalid'].includes(identity);
  }

  console.log(`IdentityCheck: ${enableIdentity} | IdentityStatus: ${identity} | pageId: ${pageId}`);

  if (!enableIdentity) {
    return (
      <ThemeProvider theme={ { config, ssoAuthConfig } }>
        <Main />
      </ThemeProvider>
    );
  }

  return (
    <IdentityCheck isIdentityCheckEnabled={ enableIdentity }>
      <ThemeProvider theme={ { config, ssoAuthConfig } }>
        {identityChecked ? <Main identity={ identity } /> : <GetNewUID />}
      </ThemeProvider>
    </IdentityCheck>
  );
};

const mapStateToProps = (state) => ({ identity: state.questions.identity });

export default connect(mapStateToProps)(InitiateApplication);
